// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_9400a595a7--dropdown--i46Zw"};